class ProductReviews extends HTMLElement {
  constructor() {
    super();
    this.perPage = parseInt(this.dataset.perPage || '5', 10);
    this.list = this.querySelector('[data-reviews-list]');
    this.pagination = this.querySelector('[data-reviews-pagination]');
    this.sortSelect = this.querySelector('[data-reviews-sort]');
    this.currentPage = 1;

    if (!this.list) return;

    this.originalOrder = Array.from(this.list.children);
    this.items = this.originalOrder.slice();

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', () => {
        this.sortItems(this.sortSelect.value);
        this.currentPage = 1;
        this.render();
      });
    }

    this.buildPagination();
    this.render();
  }

  sortItems(mode) {
    const items = this.items.slice();

    if (mode === 'newest') {
      items.sort((a, b) => new Date(b.dataset.date) - new Date(a.dataset.date));
    } else if (mode === 'oldest') {
      items.sort((a, b) => new Date(a.dataset.date) - new Date(b.dataset.date));
    } else if (mode === 'highest') {
      items.sort((a, b) => parseFloat(b.dataset.rating) - parseFloat(a.dataset.rating));
    } else if (mode === 'lowest') {
      items.sort((a, b) => parseFloat(a.dataset.rating) - parseFloat(b.dataset.rating));
    } else {
      items.sort((a, b) => this.originalOrder.indexOf(a) - this.originalOrder.indexOf(b));
    }

    items.forEach((item) => this.list.appendChild(item));
    this.items = items;
  }

  get totalPages() {
    return Math.max(1, Math.ceil(this.items.length / this.perPage));
  }

  buildPagination() {
    if (!this.pagination) return;

    if (this.totalPages <= 1) {
      this.pagination.innerHTML = '';
      return;
    }

    this.pagination.innerHTML = '';

    const maxVisible = 5;
    const visibleCount = Math.min(maxVisible, this.totalPages);

    for (let i = 1; i <= visibleCount; i += 1) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = String(i);
      button.dataset.page = i;
      button.className = 'product-reviews__page-button';
      button.addEventListener('click', () => {
        this.currentPage = i;
        this.render();
      });
      this.pagination.appendChild(button);
    }

    if (this.totalPages > maxVisible) {
      const ellipsis = document.createElement('span');
      ellipsis.className = 'product-reviews__page-ellipsis';
      ellipsis.textContent = '…';
      ellipsis.setAttribute('aria-hidden', 'true');
      this.pagination.appendChild(ellipsis);
    }
  }

  render() {
    this.items.forEach((item, index) => {
      const page = Math.floor(index / this.perPage) + 1;
      item.hidden = page !== this.currentPage;
    });

    if (this.pagination) {
      Array.from(this.pagination.querySelectorAll('[data-page]')).forEach((button) => {
        button.classList.toggle(
          'product-reviews__page-button--current',
          parseInt(button.dataset.page, 10) === this.currentPage
        );
      });
    }
  }
}

customElements.define('product-reviews', ProductReviews);
